"use client";

import { c as _c } from "react/compiler-runtime";
import { useComparisonStoreData } from "@/hooks/global-multiple";
import { trackEvent } from "@/utils/analytics/track-event";
import { ChevronUp } from "lucide-react";
import { usePathname } from "next/navigation";
import { useCallback } from "react";
export function MobileComparisonBadge() {
  const $ = _c(13);
  const comparisonTray = useComparisonStoreData(_temp);
  const isComparisonMinimized = useComparisonStoreData(_temp2);
  const setIsComparisonMinimized = useComparisonStoreData(_temp3);
  const pathname = usePathname();
  let t0;
  if ($[0] !== comparisonTray?.length || $[1] !== setIsComparisonMinimized) {
    t0 = () => {
      setIsComparisonMinimized(false);
      trackEvent({
        google: {
          event: "expand_comparison_from_badge",
          options: {
            property_count: comparisonTray?.length || 0
          }
        }
      });
    };
    $[0] = comparisonTray?.length;
    $[1] = setIsComparisonMinimized;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleClick = t0;
  if (pathname === "/compare") {
    return null;
  }
  if (!isComparisonMinimized || !comparisonTray || comparisonTray.length === 0) {
    return null;
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ChevronUp className="w-3 h-3 -rotate-90 group-hover:translate-x-[-2px] transition-transform" />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" /></svg>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== comparisonTray.length) {
    t3 = <div className="relative">{t2}<span className="absolute -top-1 -right-1 bg-white text-primary text-[9px] font-bold rounded-full w-3.5 h-3.5 flex items-center justify-center border border-primary">{comparisonTray.length}</span></div>;
    $[5] = comparisonTray.length;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex flex-col items-center [writing-mode:vertical-rl]"><span className="font-semibold text-[10px] whitespace-nowrap">Compare</span></div>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3) {
    t5 = <div className="flex flex-col items-center gap-2">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== handleClick || $[11] !== t5) {
    t6 = <div className="fixed z-50 right-0 top-1/2 -translate-y-1/2"><button onClick={handleClick} className={"bg-primary text-white shadow-lg hover:shadow-xl transition-all duration-300 group\n\t\t\t\t\tflex flex-col items-center gap-2 py-3 px-2 rounded-l-md\n\t\t\t\t\tselect-none cursor-pointer"} aria-label="Expand comparison">{t1}{t5}</button></div>;
    $[10] = handleClick;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
function _temp3(state_1) {
  return state_1.setIsComparisonMinimized;
}
function _temp2(state_0) {
  return state_0.isComparisonMinimized;
}
function _temp(state) {
  return state.comparisonTray;
}